import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Optional } from '@angular/core';
import { OKTA_AUTH, OktaAuthGuard } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { from } from 'rxjs';
import { TcpUserResolver } from './../services/tcp-user-resolver';
import { getCorrectEmailForLegacyUsers } from '../utils/okta-utils';
import { PRE_BOOTSTRAP_USER_INFO } from '../utils/pre-bootstrap-config-loader.util';
import * as i0 from "@angular/core";
import * as i1 from "@okta/okta-angular";
import * as i2 from "./../services/tcp-user-resolver";
export class OktaWrapGuard {
    constructor(oktaService, oktaGuard, tcpUserResolver, document, preBootstrapUserInfo) {
        this.oktaService = oktaService;
        this.oktaGuard = oktaGuard;
        this.tcpUserResolver = tcpUserResolver;
        this.document = document;
        this.preBootstrapUserInfo = preBootstrapUserInfo;
        // Check for pre-bootstrap user info via Angular DI (secure approach - no window globals)
        // If provided, APP_INITIALIZER already dispatched it to store, so we only need to load TCP user data
        if (this.preBootstrapUserInfo) {
            // User info already in store via APP_INITIALIZER - just load TCP user data
            console.log('🚀---- Pre-bootstrap user info available via DI, skipping userinfo call ----');
            const email = getCorrectEmailForLegacyUsers(this.preBootstrapUserInfo);
            this.tcpUserResolver.loadUserDataWithToken(email, this.oktaService.getAccessToken());
        }
    }
    canActivate(route, state) {
        this.handleHttpRedirection();
        return this.checkIfCanActivate(route, state);
    }
    canActivateChild(route, state) {
        this.handleHttpRedirection();
        return this.checkIfCanActivate(route, state);
    }
    checkIfCanActivate(route, state) {
        // Use OktaAuthGuard for authentication
        console.log('🚀🚀 -- OKTA ALWAYS ENABLED');
        return from(this.oktaGuard.canActivate(route, state));
    }
    handleHttpRedirection() {
        if (this.document.location.protocol === 'http:' &&
            this.document.location.hostname !== 'localhost' &&
            !this.document.location.href.includes('mock=true')) {
            window.location.href = this.document.location.href.replace('http', 'https');
        }
    }
    static { this.ɵfac = function OktaWrapGuard_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OktaWrapGuard)(i0.ɵɵinject(OKTA_AUTH), i0.ɵɵinject(i1.OktaAuthGuard), i0.ɵɵinject(i2.TcpUserResolver), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(PRE_BOOTSTRAP_USER_INFO, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OktaWrapGuard, factory: OktaWrapGuard.ɵfac }); }
}
//# sourceMappingURL=okta-wrap.guard.js.map